import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 136.62 82.65"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M36.11 81.9c-3.82 0-7.27-2.25-8.77-5.78L.79 14.03C-1.31 9.15.94 3.6 5.81 1.5c4.87-2.1 10.43.15 12.52 5.02L36.1 48.14 53.89 6.53c2.1-4.87 7.65-7.13 12.52-5.02s7.12 7.65 5.02 12.53l-26.55 62.1a9.517 9.517 0 0 1-8.78 5.78",
      style: {"fill":"#7d4697"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M127.04 82.65c-3.75 0-7.28-2.18-8.78-5.85l-17.77-42.52-17.7 42.52c-2.03 4.87-7.57 7.13-12.45 5.1-4.88-2.02-7.13-7.58-5.1-12.45l26.55-63.6C93.29 2.33 96.74 0 100.57 0s7.35 2.33 8.78 5.85l26.55 63.6c2.02 4.87-.3 10.42-5.1 12.45-1.27.53-2.55.75-3.75.75",
      style: {"fill":"#6fb92c"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "EB-logo"}) } }